import { useEffect } from 'react';
import './App.css';
import './styles/inputs.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import { PlayerProvider } from './context/PlayerContext';
import { AuthProvider } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import TopNav from './components/TopNav';
import PlayerBar from './components/PlayerBar';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Submit from './pages/Submit';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import { Toaster } from './components/ui/toaster';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Layout = ({ children }) => (
  <div className="flex">
    <Sidebar />
    <main className="flex-1 min-w-0 pb-[100px]">
      <TopNav />
      {children}
    </main>
  </div>
);

function App() {
  useEffect(() => {
    // Mount-only health-check ping to backend API
    axios.get(`${API}/`).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route
                path="/submit"
                element={
                  <ProtectedRoute>
                    <Layout><Submit /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireRole="super_admin">
                    <Layout><AdminDashboard /></Layout>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Layout><Home /></Layout>} />
            </Routes>
            <PlayerBar />
          </BrowserRouter>
          <Toaster />
        </PlayerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
